import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import TextField from "../../Components/Commons/Forms/TextField";
import TextArea from "../../Components/Commons/Forms/TextArea";
import SelectField from "../../Components/Commons/Forms/SelectField";
import {
  validateInventory,
} from "../../Components/Helpers/Utilities/Validations/Pharmacy";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import BtnDelete from "../../Components/Commons/Buttons/BtnDelete";
import {
  updateItem,
} from "../../Components/Helpers/API/PharmacyApi/PharmacyApi";
import { toast } from "react-toastify";
import TypeAhead from "../../Components/Commons/Forms/TypeAhead";
import { getPatients } from "../../Components/Helpers/API/PatientApi/PatientApi";
import { useNavigate } from "react-router-dom";


export default function EditItem({ refetch, initialValues }) {
  const navigateto = useNavigate();
  const [show, setShow] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [newItem, setNewItem] = useState({
    stock: "",
    type: "",
  });
  const [allPatients, setAllPatients] = useState({});
  const [showLoader, setShowLoader] = useState(false);
  const [isError, setIsError] = useState({
    item: false,
    stock: false,
    name: false,
  });

  const handleClose = () => {
    setNewItem({
      stock: "",
      type: "",
    })
    setShow(false)
  };
  const handleShow = () => setShow(true);

  const handleEditChange = (e, isChange) => {
    const name = e[0]
    handleInputChange(name?.value, isChange)
  };

  const handleInputChange = (e, type) => {
    if(type){
      setNewItem((prevState) => ({
        ...prevState,
        patient_name: e, 
      }));
    } else {
      const { name, value } = e.target;
      setNewItem((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const handleUpdate = async () => {
    setIsClicked(true);
      const res = await updateItem(newItem, initialValues);
      if (res.data) {
        toast.success(res.data.message);
        handleClose();
        refetch();
         navigateto("/inventory-logs");
      } else if (res.error) {
        if (res.error?.status === 500) {
          toast.error(`Error 500: ${res.error.data.message}`);
        } else if (res.error?.status === 400) {
          res.error.data.messages.error_messages.forEach((errMsg) =>
            toast.error(errMsg)
          );
        }
      }
    setIsClicked(false);
  };

  //get patient API
  async function fetchPatient() {
    setShowLoader(true);
    const response = await getPatients();
    if (response.data && response.data.data) {
      const allPatients = response.data.data.map((patient) => ({
        label: patient.full_name,
        value: patient.full_name,
      }));
      setAllPatients(allPatients);
    } else {
      setAllPatients([]);
    }
    
    setShowLoader(false);
  }

  useEffect(() => {
    fetchPatient();
  }, []);

  return (
    <>
      <BtnSave id={"green-btn"} label={"Stock"} size={"sm"} onClick={handleShow} />
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="form-title">Stock</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <p className="align-left form-label mb-3">
                Item: {initialValues.item || ""}
              </p>
            </Col>
            <Col>
              <p className="align-left form-label mb-3">
                Unit: {initialValues.unit || ""}
              </p>
            </Col>
          </Row>
          <Row>
            <Col>
              <SelectField
                required={true}
                formLabel={`Type`}
                name="type"
                size={`sm`}
                placeholder={"SELECT"}
                options={[
                  { value: "", label: "SELECT" },
                  { value: "stock-in", label: "Stock In" },
                  { value: "stock-out", label: "Stock Out" },
                ]}
                // value={addAdmissionData.health_condition}
                onChange={handleInputChange}
                disabled={isClicked}
              />
            </Col>
            <Col>
              <TextField
                required
                id="stock"
                name="stock"
                formLabel={`Qty`}
                size={`sm`}
                // value={newItem.stock}
                onChange={handleInputChange}
                isError={isError.stock}
                errorMessage="Stock Qty is required"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextArea
                id="remarks"
                name="remarks"
                // value={newItem.remarks}
                onChange={handleInputChange}
                formLabel={`Remarks`}
                size={`sm`}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TypeAhead
                  id={"patient_name"}
                  errorMessage="Required"
                  className="dropsearch-filter"
                  name="patient_name"
                  size={`sm`}
                  formLabel={"Patient Name"}
                  options={allPatients}
                  value={newItem.patient_name}
                  onChange={(e) => handleEditChange(e, true)}
                  onInputChange={(e) => handleInputChange(e, true)}  
                />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <BtnDelete
            label={"Close"}
            size={"md"}
            onClick={handleClose}
            isClicked={isClicked}
          />
          <BtnSave
            label={"Save changes"}
            size={"md"}
            onClick={handleUpdate}
            isClicked={isClicked}
            disabled={
              Object.values(newItem.stock).every((value) => value === "") ||
              Object.values(newItem.type).every((value) => value === "")
            }
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}
